module.exports = __webpack_public_path__ + "static/media/lettre.32a8cb6c.png";